/**
 * La taille du corpus, telle qu'on l'annonce sur « Notre IA ».
 *
 * UN SEUL CHIFFRE, ET IL EST GARDÉ
 * ────────────────────────────────
 * `CORPUS_SOURCES` vit dans `CinematiqueV6/cineData.js` — lire son
 * commentaire AVANT d'y toucher : c'est une décision produit, pas une
 * mesure, et `backend/tests/test_corpus_count.py` affiche l'écart avec le
 * compte réel de `legal_db_v2` à chaque exécution. C'est la seule
 * volumétrie que le produit publie, et c'est celle-là qu'on lit ici plutôt
 * que d'en retaper une.
 *
 * Cette page annonçait « 2,5 M de documents » à quatre endroits — un
 * facteur 600 au-dessus de la réalité. Un nombre écrit en dur ne se
 * périme pas bruyamment : il reste juste faux, tranquillement, jusqu'à ce
 * que quelqu'un le vérifie.
 *
 * L'import traverse vers un module de la cinématique, ce qui est un sens
 * de dépendance inhabituel. C'est assumé : déplacer la constante
 * casserait le test qui la relit à son chemin, et une deuxième copie
 * ici rouvrirait exactement le problème qu'on ferme.
 */
import { CORPUS_SOURCES } from '../CinematiqueV6/cineData';

const LOCALES = { fr: 'fr-BE', nl: 'nl-BE', en: 'en-GB' };

/**
 * Le chiffre publié, formaté pour la langue affichée et TOUJOURS suivi
 * d'un « + » : « 300 000+ », « 300.000+ », « 300,000+ ».
 *
 * IL N'Y A PAS DE VARIANTE SANS LE « + », et c'est délibéré. Trois écrans
 * l'interpolaient dans une phrase (« {count} documents juridiques ») via un
 * `corpusCount()` nu : ils publiaient donc un compte EXACT là où le produit
 * n'annonce qu'un ordre de grandeur. Une seule fonction, un seul rendu
 * possible.
 */
export function corpusCountPlus(language) {
  const short = String(language || 'fr').slice(0, 2).toLowerCase();
  return `${CORPUS_SOURCES.toLocaleString(LOCALES[short] || LOCALES.fr)}+`;
}

export { CORPUS_SOURCES };
